import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { TableModel } from "src/app/tinea-components/table/models/input/table-model";

export const InhibitionConnectivityActions = createActionGroup({
  source: "Inhibition Connectivity",
  events: {
    "Search All": emptyProps(),
    "Fetch Success": props<{ data: TableModel}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

